/**
 * Who may own, and who may belong to, each admin-managed kind. The API checks it
 * when a row is written (`routes/admin-doer-groups.ts`) and the dashboard's
 * Doer Groups pickers search exactly these roles, so a pick is never refused.
 * A user whose role changes later is not re-checked (the scope simply stops
 * applying to an owner whose role no longer reads the kind).
 *
 * - escalation_pod: an Escalation Officer's doers.
 * - support_team: a supervisor's direct reports (ClickUp 14zf25znmg3). A DSL
 *   who also supervises support staff can own one, and DSLs can be members
 *   (they report to a supervisor). doer-role installers stay valid members
 *   until they are converted to support_staff.
 */
export const DOER_GROUP_ROLE_RULES = {
    escalation_pod: { owners: ['escalation_officer'], members: ['doer'] },
    support_team: { owners: ['supervisor', 'dsl'], members: ['support_staff', 'doer', 'dsl'] },
};
//# sourceMappingURL=doer-groups.js.map